// Following the live tail is opt-in everywhere (see work_stream_scroll.js).
// Native mobile chat additionally refuses *any* bottom pin while a response is
// in progress, so a delayed send / keyboard pin can never land on the tail.
export function isMobileReadingChat(platform, isCoworkerChat) {
  return (platform === 'ios' || platform === 'android') && !isCoworkerChat;
}

export function shouldHoldChatScroll({ mobileReadingChat, isInferencing, hasAssistantResponse, followLive }) {
  // Cancel even delayed send/keyboard pins once the response starts. Explicit
  // jump-to-bottom remains available, as does positioning settled history.
  return mobileReadingChat && isInferencing && hasAssistantResponse && !followLive;
}
